import React from 'react';
import { useTranslate } from 'react-admin';
import Grid from '@material-ui/core/Grid';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { H2, TextField } from '~/components';
import { Section } from '~/layout';
import { TreeNode } from '~/types/Menu';
import CreateAction from './CreateAction';
import EditAction from './EditAction';
import DeleteAction from './DeleteAction';
import CopyAction from './CopyAction';
import { usePermissions } from 'react-admin';

interface Props {
  selectedNode: TreeNode | null;
}

const keyPrefix = `resources.menu`;
const l = (key: string): string => `${keyPrefix}.fields.${key}`;

const DetailsMenu = (props: Props) => {
  const { selectedNode } = props;
  const translate = useTranslate();
  const t = (key: string): string => translate(l(key));
  const classes = useStyles();
  const { permissions } = usePermissions();
  if (!permissions?.includes('dynamicMenu.view') || !selectedNode) return null;
  return (
    <Section noPaddingRight>
      <Grid container justify='space-between' className={classes.bottomSpacing2}>
        <Grid item alignItems='center' xs={4}>
          <H2 bottomSpacing={0} topSpacing={0}>
            {translate(`${keyPrefix}.show.detailsHeading`)}
          </H2>
        </Grid>
        <Grid item container xs={8} id='section-actions' justify='flex-end'>
          {permissions?.includes('dynamicMenu.create') && (
            <>
              <Grid item>
                <CopyAction menuId={selectedNode?.id} />
              </Grid>
              <Grid item>
                <CreateAction selectedType='menuItem' menuId={selectedNode?.id} />
              </Grid>
            </>
          )}
          {permissions?.includes('dynamicMenu.update') && (
            <Grid item>
              <EditAction
                selectedNode={selectedNode}
                selectedType='menu'
                menuId={selectedNode?.id}
              />
            </Grid>
          )}
          {permissions?.includes('dynamicMenu.delete') && (
            <Grid item>
              <DeleteAction selectedNode={selectedNode} selectedType='menu' />
            </Grid>
          )}
        </Grid>
      </Grid>
      <Section noPaddings>
        <Grid container spacing={4}>
          <Grid item xs={6}>
            <TextField label={t('name')}>{selectedNode?.name}</TextField>
          </Grid>
          <Grid item xs={6}>
            <TextField label={t('code')}>{selectedNode?.code}</TextField>
          </Grid>
        </Grid>
      </Section>
    </Section>
  );
};

const useStyles = makeStyles((theme) => ({
  bottomSpacing2: {
    marginBottom: theme.spacing(2),
  },
}));

export default DetailsMenu;
